import React from "react";
import "./partRequest.css";
import { useParams } from 'react-router-dom';
import { getModelById } from "../../constants/sizing-constant";
import Consuling from "../consuling/consuling";
import { Fragment } from "react";
function PartRequest() {

    const params = useParams();
    const product = [...getModelById(params.id)][0];

    return (
        <Fragment>
            <Consuling model={product.Package + " مدل " + product.label} partRequest={true} />
        </Fragment>
    );
}


export default PartRequest;